import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { layoutStore } from "@/hooks";
import ProjectChatMessages from "./ProjectChatMessages.vue";
import ProjectChatList from "./ProjectChatList.vue";

/**
 * Displays a project chat exchange between a member and SAFA AI.
 */
const __default__ = {
  name: "ProjectChat",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_unref(layoutStore).isChatMode)
    ? (_openBlock(), _createBlock(_component_q_layout, {
        key: 0,
        class: "bg-background",
        container: "",
        style: {"min-height":"inherit"},
        view: "lHh Lpr lff"
      }, {
        default: _withCtx(() => [
          _createVNode(ProjectChatList),
          _createVNode(ProjectChatMessages)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})